import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";
import { Dates } from "./GetAllConsultants";

export type ConsultantDTO = {
    name:string;
    img_url:string;
    title:string
    consultantDates:Dates[]
}
type ConsultantResponse = {
    data: object;
} & ApiError;
export const AddConsultant = (
    data: ConsultantDTO
): Promise<ConsultantResponse> => {
    return axios.post("/consultant/create", data);
};
